exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3Efp2{position:relative;margin:0 auto;padding:0 15px;max-width:1000px}._3Efp2 h1,._3Efp2 h2,._3Efp2 h3{margin:0;text-align:center}._3Efp2 h2{margin-bottom:0}._3Efp2 h3{margin-top:10px}._2xiAG{width:100%}.dtkyD{height:80px}@media (max-width:992px){.dtkyD{height:60px}}@media (max-width:480px){.dtkyD{height:40px}}.Z_Feq{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-bottom:20px}@media (max-width:992px){.Z_Feq h1{font-size:30px}}@media (max-width:480px){.Z_Feq h1{font-size:24px}}.Z_Feq img{margin-right:15px}.UngbK{margin-bottom:40px}@media (max-width:992px){.UngbK h2{font-size:18px}}@media (max-width:480px){.UngbK h2{font-size:16px}}", ""]);

// exports
exports.locals = {
	"container": "_3Efp2",
	"headerImg": "_2xiAG",
	"logoImg": "dtkyD",
	"header": "Z_Feq",
	"subline": "UngbK"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"minimize":true,"discardComments":{"removeAll":true},"localIdentName":"[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./node_modules/sass-loader/lib/loader.js!./src/components/ProductPage/ProductPage.scss
// module id = 778
// module chunks = 2